
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateOrderDtoFormGroup() {
return new FormGroup({
    number: new FormControl<number | undefined>(undefined),
    name: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    orderAt: new FormControl<string | undefined>(undefined),
    orderBy: new FormControl<number | undefined>(undefined),
    deliverAt: new FormControl<string | undefined>(undefined),
    deliverFix: new FormControl<boolean | undefined>(undefined),
    deliveredAt: new FormControl<string | undefined>(undefined),
    stocklocationId: new FormControl<number | undefined>(undefined),
    externalReference: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    notes: new FormControl<string | undefined>(undefined, [Validators.maxLength(1200)]),
    fullDelivery: new FormControl<boolean | undefined>(undefined),
})
;
}
      